import { scrollToEl } from '//goodbuygear.com/cdn/shop/t/326/assets/shared-functions.js?v=47452928736496227401730473480';

$(document).ready(() => {
    let wgFormEl = $('[data-wg-form]');
    let sellerQaFooterButtonEl = $('[data-seller-qa-footer-button]');

    sellerQaFooterButtonEl.on('click', (e) => {
        e.preventDefault();

        scrollToEl(wgFormEl);
    });
});